import { CompositeDecorator, ContentBlock, ContentState } from 'draft-js';
import Link from './link';
import {
    TextSourceBindDecorator
} from '../../../Settings/page-builder/blocks/textSourceBindDecorator';
import {
    TextDropCapDecorator
} from '../../../Settings/page-builder/blocks/textDropCapDecorator';

const findLinkEntities = (contentBlock: any, callback: any, contentState: any) => {
    contentBlock.findEntityRanges(
        (character: any) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                contentState.getEntity(entityKey).getType() === 'LINK'
            );
        },
        callback
    );
};

function findDropCapEntity(
    contentBlock: ContentBlock,
    callback: (start: number, end: number) => void,
    contentState: ContentState
) {
    contentBlock.findEntityRanges(
        (character: any) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                contentState.getEntity(entityKey).getType() === 'DROPCAP'
            );
        },
        callback
    );
}

const decorator = new CompositeDecorator([
    {
        strategy: findLinkEntities,
        component: Link
    },
    {
        strategy: (contentBlock, callback, contentState) => {
            contentBlock.findEntityRanges(
                (character) => {
                    const entityKey = character.getEntity();
                    return (
                        entityKey !== null &&
                        contentState.getEntity(entityKey).getType() === 'SOURCE'
                    );
                },
                callback
            );
        },
        component: TextSourceBindDecorator
    },
    {
        strategy: findDropCapEntity,
        component: TextDropCapDecorator
    }
]);

export default decorator;
